module.exports = __webpack_public_path__ + "static/media/step-3.c3ee255e.svg";